import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

const telegramLanguage = String(
    window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code
    || window.navigator?.language
    || 'en'
).toLowerCase().split(/[-_]/)[0];

i18n
    .use(HttpBackend)
    .use(initReactI18next)
    .init({
        lng: telegramLanguage,
        fallbackLng: 'en',
        react: {
            useSuspense: false,
        },
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json',
        },
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
